











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('CurrentUserProfileQuery')
    
    export class CurrentUserProfileQuery  {
        constructor(  ) {
            
        }

        

        

        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: CurrentUserProfileQuery ) {
                return new QueryExecutor<CurrentUserProfileQuery, CurrentUserProfile>(CurrentUserProfile, query);
            }

            

            
        
    }

    

    
        /**
        * The result model for CurrentUserProfileQuery.
        */
        export class CurrentUserProfile {
            
                
                 userId: number;
            
                
                 firstName: string;
            
                
                 lastName: string;
            
                
                 userName: string;
            
                
                 organizationName: string;
            
                
                 isAdmin: boolean;
            
                
                 preferences: string;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace CurrentUserProfileQuery.ExtraneousTypes {
        

        
    }

